import { addDays, addMinutes, addSeconds } from "date-fns";
import React from "react"
import { FormProvider, useForm } from "react-hook-form";
import { BSSDateSelector } from "../form";
import useBSSLogger from "../../hooks/useBSSLogger";
import { Box } from "@mui/material";
import BSSForm from "../form/BSSForm";
import { DefaultSubmitErrorHandler } from "../preventivo/Preventivo";

const {logger} = useBSSLogger();


const TestDateSelector = () => {
    
    const methods = useForm();
        
    const dp = Array.from({length: 15}, (v, i) => addDays(addSeconds(new Date(), 117), i));
    logger.debug("opzioni bssdateselector", dp)

    const onSubmit = data => logger.debug("dati da bss date selector", data);

    return  (
            <FormProvider {...methods}>
                <BSSForm onSubmit={methods.handleSubmit(onSubmit, DefaultSubmitErrorHandler)}>
                    <BSSDateSelector
                        name={"testdateselector"}
                        methods={methods}
                        dataProvider={dp}
                    />                
                </BSSForm>
            </FormProvider>
        
    )

}

export default TestDateSelector